import {ChangeDetectorRef, Component, OnInit, ViewChild} from "@angular/core";
import {ProcurementService, ShoppingCartListResult} from "../../services/procurement-service/procurement.service";
import {ApolloQueryObservable} from "apollo-angular";
import {AbstractVisbosComponent} from "../../../core/visbos-core/components/abstract-visbos.component";
import {SessionActions} from "../../../shared/actions/session.actions";
import {STORE_ORDER_LIMIT} from "../../../configuration";
import {ActivatedRoute, Router} from "@angular/router";
import {StockService} from "../../services/stock.service";
import {ShoppingCart} from "../../../shared/view-model/store-management/shopping-cart.type";
import {Stock} from "../../../shared/view-model/stock";
import {GenericModalComponent} from "../../../core/visbos-core/ui/forms/generic-modal/generic-modal.component";
import {FetchExpiringStocksQuery} from "../../../shared/graphql/graphql.types";
import {FormBuilder, FormGroup} from "@angular/forms";
import {AddStocksToCartComponent} from "../components/add-stocks-to-cart/add-stocks-to-cart.component";
import {tap} from 'rxjs/operators';

@Component({
  selector: 'vb-shopping-carts-view',
  templateUrl: './shopping-carts-view.component.html',
  styleUrls: ['./shopping-carts-view.component.css']
})
export class ShoppingCartsViewComponent extends AbstractVisbosComponent implements OnInit {

  private shoppingCarts$: ApolloQueryObservable<ShoppingCartListResult>;
  shoppingCarts = [];

  private expiringStocks$: ApolloQueryObservable<FetchExpiringStocksQuery>;
  currentExpiringStocks: Stock[];
  currentShoppingCart: ShoppingCart;
  newShoppingCartItems: FormGroup;

  @ViewChild('addStocksModal')
  addStocksModal: GenericModalComponent;


  constructor(sessionActions: SessionActions, private procurementService: ProcurementService, private fb: FormBuilder,
              private stockService: StockService,
              private router: Router, private route: ActivatedRoute, cd: ChangeDetectorRef) {
    super(sessionActions, cd);

    this.actions = [
      {
        label: 'Warenkörbe auf Auto-Werte zurücksetzen',
        icon: 'fa-undo',
        action: () => this.resetShoppingCarts.apply(this)
      }
    ];

  }

  ngOnInit() {
    super.ngOnInit();
    this.sessionActions.initAsyncAction('Erzeuge Bestellvorschläge...')
    this.shoppingCarts$ = this.procurementService.loadShoppingCarts();
    this.addComponentData(this.shoppingCarts$);

    this.dataSubscriptions.push(
      this.shoppingCarts$
        .pipe(
          tap(res => {
            if (res.loading) {
              this.sessionActions.initAsyncAction('Erzeuge Bestellvorschläge...');
            } else {
              this.sessionActions.finishAsyncAction('Erzeuge Bestellvorschläge...');
            }
          })
        ).subscribe(res => {
        this.shoppingCarts = res.data.shoppingCarts;
      })
    );

  }

  formatSumWarning(sum: number) {
    if (!STORE_ORDER_LIMIT) {
      return {};
    }

    return {
      'text-warning': sum >= STORE_ORDER_LIMIT
    };

  }

  resetShoppingCarts(shoppingCartCuid?: string) {
    this.procurementService.resetShoppingCart().toPromise()
      .catch(err => this.sessionActions.throwError(err, "Fehler beim Zurücksetzen!"));
  }

  onPlaceOrderClicked(cuid: string) {
    this.router.navigate([cuid, 'bestellung'], {relativeTo: this.route});
  }

  onAddExpiringStocksClicked(shoppingCartCuid: string) {

    const shoppingCart = this.shoppingCarts.find(c => c.cuid === shoppingCartCuid);
    this.newShoppingCartItems = AddStocksToCartComponent.initAddStockFormGroup(this.fb, shoppingCart);
    this.currentExpiringStocks = null;
    this.currentShoppingCart = null;

    if (!this.expiringStocks$) {
      this.expiringStocks$ = this.stockService.fetchExpiringStocks(null, null, null, shoppingCart.supplier.cuid);
      this.addSubscription(this.expiringStocks$.subscribe(
        res => {
          const shoppingCart = this.shoppingCarts.find(c => c.cuid === shoppingCartCuid);
          this.currentExpiringStocks = res.data.expiringStocks;
          this.currentShoppingCart = shoppingCart;

          // Filter out items thar allready are in the shopping cart
          this.currentExpiringStocks = this.currentExpiringStocks.filter(ex => {
            const f = this.currentShoppingCart.shopping_cart_items.find(i => i.stock_item.cuid === ex.stock_item.cuid);
            return f == null;
          });

        }
      ));
    } else {
      this.expiringStocks$.refetch({
        supplierCuid: shoppingCart.supplier.cuid
      });
    }

    this.addStocksModal.show();
  }

  isAddCartItemsFormValid(): boolean {
    return this.newShoppingCartItems && this.newShoppingCartItems.valid;
  }

  addExpiringStocks() {

    const input = this.newShoppingCartItems.value;
    this.procurementService.createShoppingCartItems(input.shopping_cart_cuid, input.shopping_cart_item_input).toPromise()
      .then(res => {
        this.newShoppingCartItems = null;
        this.currentExpiringStocks = null;
        this.currentShoppingCart = null;
      })
      .catch(err => {
        this.sessionActions.throwError(err, 'Fehler beim Hinzufügen ablaufender Bestände...', 'Warenkorb');
      });

  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/procurement/shopping-carts-view/shopping-carts-view.component.ts